function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { AxiosGraphQLError } from "../../utils/AxiosGraphQLError";
/**
 * Sets the GraphQL error interceptor.
 * It throws a GraphQLError if the response contains errors from the GraphQL API.
 * @param response The AxiosResponse instance.
 */ var setGraphQLError = function(response) {
    if (response && response.data && response.data.errors) {
        var _response_data_errors = _sliced_to_array(response.data.errors, 1), firstError = _response_data_errors[0];
        if (firstError) {
            var message = firstError.message, nodes = firstError.nodes, source = firstError.source, positions = firstError.positions, path = firstError.path, originalError = firstError.originalError, extensions = firstError.extensions;
            throw new AxiosGraphQLError(message, {
                nodes: nodes,
                source: source,
                positions: positions,
                path: path,
                originalError: originalError,
                extensions: extensions
            }, response);
        }
    }
    return response;
};
/**
 * Sets the GraphQL error interceptor.
 * It throws a GraphQLError if the response contains errors from the GraphQL API.
 * @param httpClient The HttpClient instance.
 * @param options The options for the interceptor.
 */ export var setResGraphQLError = function(httpClient, options) {
    if (options === void 0) options = {};
    var _options_onSuccess = options.onSuccess, onSuccess = _options_onSuccess === void 0 ? setGraphQLError : _options_onSuccess, _options_onError = options.onError, onError = _options_onError === void 0 ? function(err) {
        throw err;
    } : _options_onError;
    return httpClient.axios.interceptors.response.use(onSuccess, onError);
};
